module.exports = __webpack_public_path__ + "img/der_02_coin_c.38802fb8.png";